module.exports = __webpack_public_path__ + "static/img/5bg_11.f897e1b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/5bg_11.png
// module id = 724
// module chunks = 1